import React from "react";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class Calendar extends React.Component {
    state = {

        years: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

        selectedYear: false,




        currentYear: new Date().getFullYear(),

        current: 0,

        period: [2025, '-', 2015],
        ckeck: false,
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }

    yearSelector(year, extra) {
        if (extra) {
            this.setState({ check: false }, () => {
                this.changeInputValue(extra)

            })
        } else {
            let selectedYear = (this.state.currentYear - (year + (this.state.current * this.state.years.length)))
            if ((this.state.current != 0 || !this.props.header?.information?.extraOption)) {
                selectedYear = selectedYear + 1
            }
            this.setState({ selectedYear, check: false }, () => {
                this.changeInputValue(this.state.selectedYear)
            })
        }


    }
    changeInputValue(value) {
        if (value !== null) {
            // console.log(this.props.extra)
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    toggleOpen = (open) => {

        let openState = open != null ? open : !this.state.check

        if (openState) {
            document.addEventListener('mousedown', this.closeBox);


        } else {
            document.removeEventListener('mousedown', this.closeBox);
            this.setState({ check: openState })
        }

    }


    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.check) {
            this.setState({ check: false })
            document.removeEventListener('mousedown', this.closeBox);


        }
    }
    goBackYear = () => {
        if (this.state.period[0] != this.state.currentYear) {
            if (this.props.header?.information?.extraOption) {
                if (this.state.current - 1 == 0) {

                    this.setState({ years: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }, () => {


                        this.setState({
                            current: (this.state.current - 1),
                            period: [this.state.currentYear - ((this.state.current - 1) * 11), '-', this.state.currentYear - ((this.state.current) * 11) + 1]
                        })

                    })
                } else {


                    this.setState({
                        current: (this.state.current - 1),
                        period: [this.state.currentYear - ((this.state.current - 1) * 12)+1, '-', this.state.currentYear - ((this.state.current) * 12) + 2]
                    })


                }

            } else {

                this.setState({
                    current: (this.state.current - 1),
                    period: [this.state.currentYear - ((this.state.current - 1) * 12), '-', this.state.currentYear - ((this.state.current) * 12) + 1]
                })
            }
        }
    }
    goNextYear = () => {


        if (this.props.header?.information?.extraOption) {
            this.setState({ years: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] }, () => {

                this.setState({
                    current: (this.state.current + 1),
                    period: [this.state.currentYear - ((this.state.current + 1) * 12)+1, '-', this.state.currentYear - ((this.state.current + 2) * 12)+2]
                })

            })

        } else {
            this.setState({
                current: (this.state.current + 1),
                period: [this.state.currentYear - ((this.state.current + 1) * 12), '-', this.state.currentYear - ((this.state.current + 2) * 12) + 1]
            })
        }

    }
    setInitialYear = () => {


        if (this.props.header?.information?.extraOption) {

            this.setState({
                check: !this.state.check,
                period: [this.state.currentYear - (this.state.current * this.state.years.length), '-', this.state.currentYear - ((this.state.current + 1) * this.state.years.length) + 1]
            })


        } else {
            this.setState({ years: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] }, () => {
                this.setState({
                    check: !this.state.check,
                    period: [this.state.currentYear - (this.state.current * this.state.years.length), '-', this.state.currentYear - ((this.state.current + 1) * this.state.years.length) + 1]
                })
            })
        }

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }






    render() {
        return (


            <div className='mt-0' ref={ref => this.setWrapperRef(ref)} onClick={() => this.toggleOpen(true)} style={{ minWidth: '250px' }}>
                <div style={{ justifyContent: 'space-between', display: 'flex' }}>

                    <div class='flexcc'>
                        <div onClick={() => this.setInitialYear()} style={{ display: 'flex', cursor: 'pointer', fontSize: '15px', alignItems: 'center' }}>

                            {this.props.data ? this.props.data : <a style={{ color: '#778899', fontSize: '15px' }} >{this.props.header.information.placeholder}</a>}
                        </div>


                        <div style={{ display: (this.state.check ? 'block' : 'none'), position: 'absolute', top: '120%', left: '10%', right: '10%', zIndex: 40, direction: 'ltr',backgroundColor:'#fff' }}>
                            <ul class='days'>

                                <div className="flexcc" style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '10px', paddingTop: '0', borderBottom: '1px solid #D7D9DD', margin: '20px' }}>
                                    {this.state.period}
                                    <div class='flexcc'>
                                        {/* {this.state.period[0] != this.state.currentYear && ( */}

                                        <img onClick={() => this.goBackYear()}
                                            src="/images/chevron-left.png" height='20px' style={{ cursor: 'pointer', opacity: this.state.period[0] != this.state.currentYear ? 1 : .5 }} />
                                        {/* )} */}
                                        <img onClick={() => this.goNextYear()}
                                            src="/images/chevron-right.png" height='20px' style={{ cursor: 'pointer' }} />
                                    </div>
                                </div>
                                {
                                    this.state.current === 0 && this.props.header?.information?.extraOption &&
                                    <li onClick={() => this.yearSelector(null,this.props.header?.information?.extraOption)}>
                                        <span className={this.props.data === 'extra' ? 'active' : ''} style={{ cursor: 'pointer' }}>
                                            {this.props.header.information.extraOption}
                                        </span>
                                    </li>
                                }
                                {this.state.years?.map((year) => {
                                    return (
                                        <li onClick={() => this.yearSelector(year)} >
                                            <span className={this.props.data == (this.state.currentYear - (year + (this.state.current * this.state.years.length))) ? 'active' : ''} style={{ cursor: 'pointer' }} > {(this.state.current == 0 && this.props.header?.information?.extraOption) ? this.state.currentYear - (year + (this.state.current * this.state.years.length)) : this.state.currentYear - (year + (this.state.current * this.state.years.length - 1))}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>


                    </div>

                    {/* <label for={this.props.headerkey} className={'mb-2 mr-1 ml-1 boldiransansfont ' + (this.conditionalSettings('required', true) ? 'required' : '')} style={{ marginBottom: 3, marginTop: 5, fontSize: 13, color: '#456',fontWeight:'bold' }}>{this.props.label}</label>
                    <label for={this.props.headerkey} className={'mb-2 mr-1 ml-1 boldiransansfont '} style={{ marginBottom: 3, marginTop: 5, fontSize: 13, color: '#789' }}>{this.props.englishlabel?.toUpperCase()}</label> */}
                </div>
                {/* <input id={this.props.headerkey} placeholder={this.props.settings?.placeholder} name={this.props.headerkey} type={(this.props.settings && this.props.settings.type )?this.props.settings.type:'text'} disabled={this.conditionalSettings('disabled', true)} onChange={e => { this.props.onChange(this.props.headerkey, e.target.value) }} className='mediumiransansfont form-control' defaultValue={this.props.title} style={{ backgroundColor: '#f4f6f8', fontSize: 13, color: '#3b3a40' }} /> */}
            </div>

        );
    }
}

export default Calendar;